export enum DocumentTypes {
  CERTIFICATE_OF_COMPLETION = 'Certificate of Completion',
  RECEIPT = 'Receipt',
  CONFIRMATION_LETTER = 'Confirmation Letter',
  ATTENDANCE_LOG = 'Attendance Log',
  SCREENSHOT = 'Screenshot',
  OTHER = 'Other',
}
